"use strict";

exports.__esModule = true;
exports.IntersectionObserver = void 0;
var IntersectionObserver = typeof window !== 'undefined' && window.IntersectionObserver;
exports.IntersectionObserver = IntersectionObserver;